import ProductService from 'src/lib/api/product.service';

export async function searchProducts({ commit }, { params }) {
  const response = await ProductService.searchProducts({ params });
  if (response.status === 200) {
    commit('updateProducts', { products: response.data.data });
    commit('updateMeta', {
      meta: {
        next: response.data.next,
        previous: response.data.previous,
        rowCount: response.data.total,
      },
    });
  }
}

export async function getProduct({ commit }, { id, include }) {
  const response = await ProductService.getProduct({ id, include });
  if (response.status === 200) {
    commit('updateCurrentProduct', { product: response.data });
  }
}

export async function createProductAsset(context, {
  id, name, type, description,
}) {
  const response = await ProductService.createProductAsset({
    id, name, type, description,
  });

  return response;
}

export async function createProduct(context, { product }) {
  await ProductService.createProduct({ product });
}

export async function updateProduct(context, { id, product }) {
  await ProductService.updateProduct({ id, product });
}

export async function deleteProduct(context, { id }) {
  await ProductService.deleteProduct({ id });
}

export async function publishProduct(context, { id }) {
  await ProductService.publishProduct({ id });
}

export async function unPublishProduct(context, { id }) {
  await ProductService.unPublishProduct({ id });
}

export async function copyProductText(context, { textId, productIds }) {
  await ProductService.copyText({ textId, productIds });
}
